import { ReactNode } from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import { CloseX } from 'shared/icons/CloseX';
import { variableFontRegular } from 'styles/theme/text';
import { Stack } from 'shared/components/Stack';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.buyBar.VariantDetailLinkHeader';

export interface IVariantDetailLinkHeaderProps {
  className?: string;
  before?: ReactNode;
  title: string;
  href: string;
  after?: ReactNode;
  onClose?: () => void;
}

export const VariantDetailLinkHeader = ({
  className,
  before,
  title,
  href,
  after,
  onClose,
}: IVariantDetailLinkHeaderProps) => {
  return (
    <VariantDetailLinkHeader.Root className={className} direction="row" spacing="24px">
      {before}
      <VariantDetailLinkHeader.LinkWrapper>
        <Link href={href} passHref legacyBehavior>
          <VariantDetailLinkHeader.Link>{title}</VariantDetailLinkHeader.Link>
        </Link>
      </VariantDetailLinkHeader.LinkWrapper>
      {after}
      {onClose && (
        <VariantDetailLinkHeader.Close
          aria-label={t(`${TP}.close`, 'Close')}
          data-qa="variant_detail_close_button"
          onClick={onClose}
        >
          <CloseX size={10} />
        </VariantDetailLinkHeader.Close>
      )}
    </VariantDetailLinkHeader.Root>
  );
};

VariantDetailLinkHeader.Root = styled(Stack)`
  flex-grow: 1;
  ${variableFontRegular({ height: '9px', size: '9' })};
`;

VariantDetailLinkHeader.LinkWrapper = styled.span`
  flex-grow: 1;
`;

VariantDetailLinkHeader.Link = styled.a`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: underline;
  padding-bottom: 1px;
`;

VariantDetailLinkHeader.Close = styled.button`
  cursor: pointer;
  grid-column-start: 3;
  text-align: right;
  padding: unset;
`;
